import { ArrowUpRight } from "lucide-react"
import Image from "next/image"
import Link from "next/link"
import { blogs } from "@/data/blogs"

export default function BlogInsights() {
  return (
    <section className="px-4 pb-10 pt-4 sm:px-6 md:pb-14 md:pt-5">
      <div className="text-center">
        <div className="inline-flex items-center rounded-full border border-black px-4 py-1.5 text-sm font-medium">
          Blogs & Insights
        </div>
        <h2 className="mx-auto mt-4 max-w-4xl text-xl font-semibold leading-[1.3] text-[#111] sm:text-2xl md:text-4xl">
          What’s new at Michigan Manufacturing International
        </h2>
        <div className="mx-auto mt-4 h-[3px] w-24 rounded-full bg-[#FDC300]" />
      </div>

      <div className="mt-8 flex gap-4 overflow-x-auto pb-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-4">
        {blogs.map((blog) => (
          <article
            key={blog.slug}
            className="group flex min-w-[82%] snap-start flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg sm:min-w-[62%] md:min-w-0"
          >
            <div className="relative h-40 overflow-hidden bg-[#111] sm:h-44">
              <Image
                src={blog.image}
                alt={blog.title}
                fill
                sizes="(max-width: 768px) 82vw, (max-width: 1024px) 50vw, 25vw"
                className="object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <span className="absolute bottom-3 left-3 inline-flex rounded-full bg-[#FDC300] px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-black">
                {blog.category}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-5">
              <h3 className="text-base font-semibold leading-snug text-[#111]">
                {blog.title}
              </h3>
              <p className="mt-2 line-clamp-3 text-sm leading-6 text-gray-600">
                {blog.tldr}
              </p>

              <Link
                href={`/blogs/${blog.slug}`}
                className="mt-5 inline-flex items-center rounded-[30px] bg-[#FDC300] px-[18px] py-[9px] text-sm font-semibold text-black transition-all hover:brightness-95"
              >
                Read Article
                <ArrowUpRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          href="/blogs"
          className="inline-flex items-center gap-2 rounded-full border border-black px-5 py-2.5 text-sm font-semibold text-black transition hover:bg-black hover:text-white"
        >
          View All Blogs
          <ArrowUpRight size={16} />
        </Link>
      </div>
    </section>
  )
}